import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/shop/OutletPage';
import Dash from './pages/admin/Dash';
import Data from './pages/admin/Data';
import UserDash from './pages/admin/UserDash';
import ReloadDash from './pages/admin/ReloadDash';
import Promoter from './pages/promoter/promoter';
import MasterDataTable from './pages/report/MasterDataTable';
import ScratchCardStats from './pages/my/ScratchCardStats';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <Routes>
          <Route path="/" element={<App />} />
          <Route path="/outlet" element={<LandingPage />} />
          <Route path="/admin" element={<Dash/>} />
          <Route path="/user-dash" element={<UserDash/>} />
          <Route path="/reload" element={<ReloadDash/>} />
          <Route path="/promoter" element={<Promoter/>} />
          <Route path="/report" element={<MasterDataTable/>} />
          <Route path="/full-report" element={<Data/>} />
          <Route path="/my" element={<ScratchCardStats/>} />
      </Routes>
    </Router>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
